import script from "./spinView.vue?vue&type=script&setup=true&lang=js"
export * from "./spinView.vue?vue&type=script&setup=true&lang=js"

import "./spinView.vue?vue&type=style&index=0&id=c97f9e70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c97f9e70"]])

export default __exports__